export default {"src":"/_next/static/media/gw.8faf6001.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};